import type { Styles } from '@adornis/ass/style.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-icon.js';
import { XFileInput } from '@adornis/file-utils/client/x-file-input.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @element sg-file-input
 */
@customElement('sg-file-input')
export class SGFileInput extends XFileInput {
  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        // shadow DOM without Tailwind: the former x-flex layout lives here
        '.row': { display: 'flex', alignItems: 'center', gap: this.spacing.sm },
        '.container': { display: 'flex', flex: '1' },
        '.container>x-formfield-wrapper': { width: '100%' },
      },
    ];
  }

  @property() clearable = true;

  override connectedCallback(): void {
    super.connectedCallback();
    this.clearable ? this.setAttribute('clearable', '') : this.removeAttribute('clearable');
  }

  override render() {
    const fileID = Array.isArray(this.value.value) ? this.value.value[0] : (this.value.value as string);
    return html`
      <div class="row">
        <div class="container">${super.render()}</div>
        ${
          fileID
            ? html`
                <x-icon
                  @click=${() => {
                    goTo(AdornisFile.getServeLink(fileID), { target: '_blank' });
                  }}
                  ${css({
                    padding: this.spacing.xs,
                    borderRadius: '50%',
                    border: `2px dashed ${this.colors.black || 'black'}`,
                    fontSize: this.spacing.md,
                    color: this.colors.black,
                    cursor: 'pointer',
                  })}
                >
                  open_in_new
                </x-icon>
              `
            : nothing
        }
      </div>
    `;
  }
}
